eSocial.ComparadorDeXml = (function()
{
    var comparar = function (elementIdA, elementIdB, elementResult)
    {
        var valueA = $(elementIdA).val();
        var valueB = $(elementIdB).val();

        montarComparador(valueA, valueB, elementResult);
    }

    var montarComparador = function(conteudoOrigem, conteudoDestino, elementId){
        conteudoOrigem = eSocial.FormatadorDeXml.formatXml3Th(conteudoOrigem);
        conteudoDestino = eSocial.FormatadorDeXml.formatXml3Th(conteudoDestino);

        import('ace-diff/dist/ace-diff.min').then(function (module)
        {            
            let diff = module.default;
            new diff({
                element: elementId,
                left: {
                    editable: false,
                    copyLinkEnabled: false,
                    content: conteudoOrigem
                },
                right: {
                    editable: false,
                    copyLinkEnabled: false,
                    content: conteudoDestino
                }
            });
        });
    }

    return {
        comparar: function (elementIdA, elementIdB, elementResult){
            comparar(elementIdA, elementIdB, elementResult);
        },
    }
})();